module.exports = __webpack_public_path__ + "static/media/user-red.d2e1e06e.svg";